import {store} from "../../index";
import {
  SET_FORECAST_RC_DATA,
} from "./mutations";
import ForecastReasonableCompensation from "../../../models/valuation/ForecastReasonableCompensation";

export const generateForecastRC = (options = { clearCache: false }) => (dispatch) => {
  const { currentForecastRC } = store.getState().forecastRC
  const { growthRate } = store.getState().taxes

  if (currentForecastRC && !options.clearCache) {
    dispatch({ type: SET_FORECAST_RC_DATA, payload:  new ForecastReasonableCompensation({
        ...currentForecastRC,
        onePlusGrowthRate: 1 + (growthRate / 100)
    })})

    return
  }

  const forecastRC = new ForecastReasonableCompensation({
    onePlusGrowthRate: 1 + (growthRate/100)
  })

  dispatch({ type: SET_FORECAST_RC_DATA, payload: forecastRC })
}

export const updateForecastRC = ({ salary, benefitsPercentage, analystNote }) => (dispatch) => {
  const { currentForecastRC } = store.getState().forecastRC

  const _currentForecastRC = new ForecastReasonableCompensation({
    ...currentForecastRC
  })

  if (salary || salary === "") _currentForecastRC.salary = salary
  if (benefitsPercentage || benefitsPercentage === "") _currentForecastRC.benefitsPercentage = benefitsPercentage
  if (analystNote || analystNote === "") _currentForecastRC.analystNote = analystNote

  dispatch({
    type: SET_FORECAST_RC_DATA,
    payload: new ForecastReasonableCompensation({
      ..._currentForecastRC
    })
  })
}


